import React, { useEffect } from "react";

import Main from '../components/TradingProducts/Main'
import Switcher from "../components/TradingProducts/Switcher";

function Trading () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div>
            <Main/>
            <Switcher/>
        </div>
    );
}

export default Trading;